/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ExternalProjectLinksControllerFindOneQueryResponse, ExternalProjectLinksControllerFindOnePathParams, ExternalProjectLinksControllerFindOneQueryParams, ExternalProjectLinksControllerFindOne400, ExternalProjectLinksControllerFindOne401, ExternalProjectLinksControllerFindOne403, ExternalProjectLinksControllerFindOne404 } from "../../models/externalProjectLinksController/ExternalProjectLinksControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { externalProjectLinksControllerFindOne } from "../../clients/external-project-linksService/externalProjectLinksControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const externalProjectLinksControllerFindOneQueryKey = (id: ExternalProjectLinksControllerFindOnePathParams["id"], params: ExternalProjectLinksControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/external-project-links/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ExternalProjectLinksControllerFindOneQueryKey = ReturnType<typeof externalProjectLinksControllerFindOneQueryKey>;
export function externalProjectLinksControllerFindOneQueryOptions(id: ExternalProjectLinksControllerFindOnePathParams["id"], params?: ExternalProjectLinksControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = externalProjectLinksControllerFindOneQueryKey(id, params);
  return queryOptions<ExternalProjectLinksControllerFindOneQueryResponse, ResponseErrorConfig<ExternalProjectLinksControllerFindOne400 | ExternalProjectLinksControllerFindOne401 | ExternalProjectLinksControllerFindOne403 | ExternalProjectLinksControllerFindOne404>, ExternalProjectLinksControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return externalProjectLinksControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get an external project link by ID
 * {@link /api/v1/external-project-links/:id}
 */
export function useExternalProjectLinksControllerFindOne<TData = ExternalProjectLinksControllerFindOneQueryResponse, TQueryData = ExternalProjectLinksControllerFindOneQueryResponse, TQueryKey extends QueryKey = ExternalProjectLinksControllerFindOneQueryKey>(id: ExternalProjectLinksControllerFindOnePathParams["id"], params?: ExternalProjectLinksControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ExternalProjectLinksControllerFindOneQueryResponse, ResponseErrorConfig<ExternalProjectLinksControllerFindOne400 | ExternalProjectLinksControllerFindOne401 | ExternalProjectLinksControllerFindOne403 | ExternalProjectLinksControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? externalProjectLinksControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...externalProjectLinksControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ExternalProjectLinksControllerFindOne400 | ExternalProjectLinksControllerFindOne401 | ExternalProjectLinksControllerFindOne403 | ExternalProjectLinksControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}